
import { ApplicationUserModel, ProjectModel } from '@/libs/Api';
import { CrudAction, CrudReponse } from '@/libs/core/+state/models/crud-action';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import Page from '@/Page.vue';
import { Component, Prop, Ref, Watch } from 'vue-property-decorator';
import { applicationUserStore } from '@/libs/user-settings/+state/store';
import { Guid } from '@/libs/common/functions/guid';
import { projectsStore } from '@/libs/projects/+state/store';
import ProjectScrapReasonList from '@/libs/settings/components/ProjectScrapReasonList.vue';

@Component({
    components: { ProjectScrapReasonList },
})
export default class ProjectDialog extends Page {
    id!: string;
    dialog = false;
    valid = true;
    saving = false;
    loading = false;
    applicationUser: ApplicationUserModel = applicationUserStore.useGetter(CrudGetter.Detail) as ApplicationUserModel;
    project: ProjectModel | null = null;
    deleteDialog = false;
    deleting = false;

    @Ref() form!: any;

    get isNewItem(): boolean {
        return this.project?.id == Guid.EmptyGuid();
    }

    open(id: string) {
        this.dialog = true;
        this.id = id;
        this.load();
    }

    close() {
        this.dialog = false;
    }

    private load(): Promise<any> {
        if (this.id != Guid.EmptyGuid()) {
            this.loading = true;
            return new Promise((resolve, reject) => {
                this.loadProject()
                    .then((e) => {
                        this.loading = false;
                        resolve(e);
                    })
                    .catch((e: any) => {
                        reject(e);
                    });
            });
        } else {
            this.project = {
                id: Guid.EmptyGuid(),
                code: '',
                name: '',
                projectScrapReasons: [],
            } as ProjectModel;
            return new Promise((resolve, reject) => {
                resolve(null);
            });
        }
    }

    private loadProject() {
        return new Promise((resolve, reject) => {
            projectsStore.dispatch(CrudAction.Get, { id: this.id });
            this.subscribe(projectsStore, CrudReponse.Get)
                .then((e) => {
                    this.project = e;
                    resolve(e);
                })
                .catch((e: any) => {
                    reject(e);
                });
        });
    }

    private save() {
        if (this.form.validate()) {
            const project = { ...this.project };
            this.saving = true;
            if (this.id == Guid.EmptyGuid()) {
                projectsStore.dispatch(CrudAction.Create, { item: project });
                this.subscribe(projectsStore, CrudReponse.Create)
                    .then(() => {
                        this.load().then(() => {
                            this.saving = false;
                            this.close();
                        });
                    })
                    .catch((e) => {
                        this.saving = false;
                        throw e;
                    });
            } else {
                projectsStore.dispatch(CrudAction.Update, { item: project });
                this.subscribe(projectsStore, CrudReponse.Update)
                    .then(() => {
                        this.load().then(() => {
                            this.saving = false;
                            this.close();
                        });
                    })
                    .catch((e) => {
                        this.saving = false;
                        throw e;
                    });
            }
        }
    }

    deleteClick() {
        this.deleteDialog = true;
    }

    deleteProject() {
        this.deleting = true;
        projectsStore.dispatch(CrudAction.Delete, { id: this.id });
        this.subscribe(projectsStore, CrudReponse.Delete)
            .then((e: any) => {
                this.deleting = false;
                this.deleteDialog = false;
                this.close();
            })
            .catch((e: any) => {
                this.deleting = false;
            });
    }
}
